import { render, staticRenderFns } from "./PlayerForm.vue?vue&type=template&id=2de361b2&scoped=true&"
import script from "./PlayerForm.vue?vue&type=script&lang=js&"
export * from "./PlayerForm.vue?vue&type=script&lang=js&"
import style0 from "./PlayerForm.vue?vue&type=style&index=0&id=2de361b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de361b2",
  null
  
)

export default component.exports